// pages/FAQManagement/FaqPage.jsx
import React, { useState, useEffect } from 'react';
import FaqTable from '../../components/FAQ/FaqTable';
import FaqForm from '../../components/FAQ/FaqForm';
import api from '../../api'; // مسیر ایمپورت رپر api شما

const FaqPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingFaq, setEditingFaq] = useState(null);

  useEffect(() => {
    loadFaqs();
  }, []);

  const loadFaqs = async (search = '') => {
    setLoading(true);
    try {
      // استفاده از ساختار رپر api شما
      // در صورت وجود مقدار سرچ، به کوئری استرینگ الحاق می‌شود
      const response = await api.get('home/faq/');
      setFaqs(response.data);
    } catch (error) {
      console.error('Error loading FAQs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingFaq(null);
    setShowForm(true);
  };

  const handleEdit = (faq) => {
    setEditingFaq(faq);
    setShowForm(true);
  };

  const handleDelete = async (faq) => {
    if (window.confirm(`آیا از حذف پرسش "${faq.question}" مطمئن هستید؟`)) {
      try {
        await api.delete(`home/faq/${faq.id}/`);
        loadFaqs();
      } catch (error) {
        console.error('Error deleting FAQ:', error);
        alert('متاسفانه در حین حذف خطایی رخ داد.');
      }
    }
  };

  const handleSubmit = async (formData) => {
    try {
      if (editingFaq) {
        // متد ویرایش با PUT
        await api.put(`home/faq/${editingFaq.id}/`, formData);
      } else {
        // متد ساخت با POST
        await api.post('home/faq/', formData);
      }
      setShowForm(false);
      loadFaqs();
    } catch (error) {
      console.error('Error saving FAQ:', error);
    }
  };

  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        {/* هدر صفحه و نوار ابزار */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">


            {/* دکمه افزودن سوال جدید با تم رنگی مد نظر شما */}
            <button
              onClick={handleCreate}
              className="bg-[#1E3A5F] text-[#FFC107] hover:bg-[#2B5388] hover:text-[#D19D00] px-4 py-2 rounded-lg flex items-center gap-2 transition-colors text-sm font-semibold shadow-sm"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              افزودن پرسش جدید
            </button>
          </div>
        </div>

        {/* جدول نمایش لیست پرسش‌ها */}
        <FaqTable
          faqs={faqs}
          loading={loading}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />

        {/* مودال چند منظوره (ویرایش / ثبت جدید) */}
        {showForm && (
          <FaqForm
            faq={editingFaq}
            onSubmit={handleSubmit}
            onCancel={() => setShowForm(false)}
          />
        )}
      </div>
    </div>
  );
};

export default FaqPage;
